import { Goal } from '@griply/types';

export type FilterGoalsOptions = {
  hideUnplanned?: boolean;
  hideCompleted?: boolean;
  hideArchived?: boolean;
};

export const filterGoals = (
  goals: Goal[],
  { hideUnplanned, hideCompleted, hideArchived }: FilterGoalsOptions,
): Goal[] => {
  if (!hideUnplanned && !hideCompleted && !hideArchived) {
    return goals;
  }

  return goals.filter((goal) => {
    if (hideUnplanned && (!goal.startDate || !goal.deadline)) {
      return false;
    }

    if (hideCompleted && !!goal.completedAt) {
      return false;
    }

    return !(hideArchived && !!goal.archivedAt);
  });
};
